import BarGroup from '../pages/BarGroup/BarGroup';
import BarSelectTheatreAndTime from '../pages/BarSelectTheatreAndTime/BarSelectTheatreAndTime';
import Buy from '../pages/Buy/Buy';
import Fail from '../pages/Fail/Fail';
import FilmSchedule from '../pages/FilmSchedule/FilmSchedule';
import GeneralSchedule from '../pages/GeneralSchedule/GeneralSchedule';
import Home from '../pages/Home/Home';
import Login from '../pages/Login/Login';
import MainPage from '../pages/MainPage/MainPage';
import Success from '../pages/Success/Success';
import SupportCulturalProgram from '../pages/SupportCulturalProgram/SupportCulturalProgram';

export const routesInApi = [
  { api: 'ToGeneralSchedule', name: 'generalSchedule' },
  { api: 'ToFilmSchedule', name: 'filmSchedule' },
  { api: 'ToChooseTheatreForBar', name: 'beforeBar' },
  { api: 'ToHallPlan', name: 'home' },
  { api: 'ToPaymentResult', name: 'success' },
  { api: 'ToBar', name: 'barGroup' },
  { api: 'ToPayment', name: 'buy' },
  { api: 'ToBank', name: 'bank' },
  { api: 'ToPaymentResult', name: 'fail' },
  { api: 'ToPaymentResult', name: 'success' },
];

const routes = [
  {
    path: '/generalSchedule/:cityId/:theatreId',
    name: 'generalSchedule',
    component: GeneralSchedule,
  },
  {
    path: '/generalSchedule/:cityId',
    name: 'generalSchedule',
    component: GeneralSchedule,
  },
  {
    path: '/generalSchedule',
    name: 'generalSchedule',
    component: GeneralSchedule,
  },
  {
    path: '/success',
    name: 'success',
    component: Success,
  },
  {
    path: '/fail',
    name: 'fail',
    component: Fail,
  },
  {
    path: '/filmSchedule',
    name: 'filmSchedule',
    component: FilmSchedule,
  },
  {
    path: '/',
    name: 'mainPage',
    component: MainPage,
  },
  {
    path: '/bar',
    name: 'beforeBar',
    component: BarSelectTheatreAndTime,
  },
  {
    path: '/:theatreId/:session/hall',
    name: 'home',
    component: Home,
  },
  {
    path: '/:theatreId/:session/support-cultural-program',
    name: 'support-cultural-program',
    component: SupportCulturalProgram,
  },
  {
    path: '/:theatreId/bar',
    name: 'barGroup',
    component: BarGroup,
  },
  {
    path: '/:theatreId/:session/bar',
    name: 'barGroup',
    component: BarGroup,
  },
  {
    path: '/:theatreId/buy',
    name: 'buy',
    component: Buy,
  },
  {
    path: '/:theatreId/:session/buy',
    name: 'buy',
    component: Buy,
  },
  {
    path: '/:theatreId/:session/login',
    name: 'login',
    component: Login,
  },
];

export default routes;
